import React, { useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import MainCard from "../../components/MainCard";
import moment from "moment";

const testTypeFieldMap = {
  API: [
    {
      label: "Label",
      field: "label",
      fallbackField: "iterationId",
      type: "string",
    },
    { label: "Test Type", field: "testType", type: "string" },
    {
      label: "Test Environment",
      field: "testEnvironment",
      type: "string",
    },
    { label: "Tags", field: "tags", type: "string" },
    { label: "Collection Name", field: "collectionName", type: "string" },
    {
      label: "Environment Name",
      field: "environmentName",
      type: "string",
    },
    {
      label: "Total Iterations",
      field: ["iterations", "total"],
      type: "number",
    },
    {
      label: "Execution Date",
      field: "executionDate",
      type: "date",
    },
    {
      label: "Execution Start Time",
      field: "executionStartTime",
      type: "date",
    },
    { label: "Execution End Time", field: "executionEndTime", type: "date" },
  ],
  WEB: [
    {
      label: "Label",
      field: "label",
      fallbackField: "iterationId",
      type: "string",
    },
    { label: "Test Type", field: "testType", type: "string" },
    {
      label: "Test Environment",
      field: "testEnvironment",
      type: "string",
    },
    { label: "Tags", field: "tags", type: "string" },
    { label: "Browser Used", field: "browserUsed", type: "string" },
    { label: "Browser Version", field: "browserVersion", type: "string" },
    { label: "Execution Date", field: "executionDate", type: "date" },
    {
      label: "Execution Start Time",
      field: "executionStartTime",
      type: "date",
    },
    { label: "Execution End Time", field: "executionEndTime", type: "date" },
  ],
  MOBILE: [
    {
      label: "Label",
      field: "label",
      fallbackField: "iterationId",
      type: "string",
    },
    { label: "Test Type", field: "testType", type: "string" },
    {
      label: "Test Environment",
      field: "testEnvironment",
      type: "string",
    },
    { label: "Tags", field: "tags", type: "string" },
    { label: "Device Name", field: "deviceName", type: "string" },
    { label: "Platform Name", field: "platformName", type: "string" },
    { label: "Platform Version", field: "platformVersion", type: "string" },
    { label: "App Version", field: "appVersion", type: "string" },
    { label: "Execution Date", field: "executionDate", type: "date" },
    {
      label: "Execution Start Time",
      field: "executionStartTime",
      type: "date",
    },
    { label: "Execution End Time", field: "executionEndTime", type: "date" },
  ],
};

const SummaryTable = ({ iteration, isLoading }) => {
  const [fieldsToDisplay, setFieldsToDisplay] = React.useState([]);
  useEffect(() => {
    if (iteration?.testType) {
      switch (iteration.testType) {
        case "API":
          setFieldsToDisplay(testTypeFieldMap.API);
          break;
        case "WEB":
          setFieldsToDisplay(testTypeFieldMap.WEB);
          break;
        case "MOBILE":
          setFieldsToDisplay(testTypeFieldMap.MOBILE);
          break;
        default:
          setFieldsToDisplay(testTypeFieldMap.WEB);
      }
    }
  }, [iteration, isLoading]);

  return (
    <MainCard
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
      contentSX={{
        height: "100%",
      }}>
      <TableContainer component={Paper} sx={{ height: "100%" }}>
        <Table
          aria-labelledby="tableTitle"
          size="small"
          sx={{ height: "100%" }}>
          <TableBody>
            {fieldsToDisplay.map((field, index) => {
              const value = Array.isArray(field.field)
                ? iteration?.[field.field[0]]?.[field.field[1]]
                : iteration?.[field.field] || iteration?.[field.fallbackField];

              return value ? (
                <TableRow
                  hover
                  key={index}
                  sx={{
                    "&:nth-of-type(odd)": {
                      backgroundColor: (theme) => theme.palette.action.hover,
                    },
                  }}>
                  <TableCell
                    sx={{
                      padding: "6px 8px",
                    }}>
                    <Typography variant="subtitle1">{field?.label}</Typography>
                  </TableCell>
                  <TableCell
                    sx={{
                      padding: "6px 8px",
                    }}>
                    <Typography>
                      {field?.type === "date"
                        ? moment(value).format("MMMM Do YYYY, h:mm:ss a")
                        : Array.isArray(value)
                        ? value.join(", ")
                        : value}
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : null;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </MainCard>
  );
};

export default SummaryTable;
